module.exports = __webpack_public_path__ + "img/copy-icon.35ee6c2b.svg";